import { Button, Flex, Stack, Tag, Text, Tooltip, useColorModeValue } from "@chakra-ui/react"
import OfflineFilter from "components/status/OfflineFilter"
import { MdMyLocation, MdRefresh } from "react-icons/md"

// Title, counters, the "Offline" filter and buttons above the map.
// `status` is the state of the user's position (see useUserPosition).
export default function MapToolbar({ onMap, withoutCoordinates, status, hasPosition, mapReady, loading, offline, offlineCount, onOfflineChange, onLocate, onShowUser, onRefresh }) {
  const titleColor = useColorModeValue("secondaryGray.900", "white")

  const userButtonLabel = status === "denied"
    ? "Location access is blocked in the browser settings"
    : status === "unavailable"
      ? "Your location could not be determined. Click to try again."
      : "Centre the map on your location"

  return (
    <Flex px="25px" py="16px" justify="space-between" align="center" wrap="wrap" gap={3}>
      <Stack direction="row" align="center" spacing={3} wrap="wrap">
        <Text fontSize="xl" fontWeight="bold" color={titleColor}>Locations map</Text>
        <Tag size="sm" colorScheme="brand" variant="subtle">{onMap} on the map</Tag>
        {withoutCoordinates > 0 && (
          <Tooltip label="These locations have no coordinates. Open the location and save it again to find them from its address.">
            <Tag size="sm" colorScheme="orange" variant="subtle">{withoutCoordinates} without coordinates</Tag>
          </Tooltip>
        )}
      </Stack>
      <Stack direction="row" spacing={0} gap={3} align="center" wrap="wrap">
        <OfflineFilter isChecked={offline} count={offlineCount} onChange={onOfflineChange} />
        <Tooltip label={userButtonLabel}>
          <Button size="sm" colorScheme="brand" variant="outline" borderRadius="30px" leftIcon={<MdMyLocation />}
            isLoading={status === "pending"}
            isDisabled={status === "denied" || !mapReady}
            onClick={hasPosition ? onShowUser : onLocate}>
            My location
          </Button>
        </Tooltip>
        <Button size="sm" colorScheme="brand" borderRadius="30px" leftIcon={<MdRefresh />}
          isLoading={loading} onClick={onRefresh}>
          Refresh
        </Button>
      </Stack>
    </Flex>
  )
}
